module.exports = __webpack_public_path__ + "static/img/visa_bg_visit.73aacd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/products/visa_bg_visit.png
// module id = sXLI
// module chunks = 4